import React from "react";
import { DropdownSingle } from "oolib";

export const ContentTypeSelector = ({ 
  selectedTpl, 
  onTplChange, 
  tplOptions, 
  isVisible = true 
}) => {
  if (!isVisible) return null;

  return (
    <div
      style={{
        padding: "8px 14px",
        borderBottom: `1px solid #E5E7EB`,
        marginBottom: "8px",
      }}
    >
      <DropdownSingle
        id="tpl"
        S
        label={"Content Type"}
        placeholder={"Select One"}
        saveValueAsString
        value={selectedTpl}
        onChange={(k, v) => onTplChange(v)}
        options={tplOptions}
      />
    </div>
  );
}; 